<template>
  <div :style="containerStyle">
    <slot></slot>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    vGap?: number
    hGap?: number
    vertical?: boolean
    justify?: "start" | "center" | "end" | "space-between" | "space-around"
    alignContent?: "start" | "center" | "end"
    alignItems?: "start" | "center" | "end" | "baseline"
    wrap?: boolean
    full?: boolean
  }>(),
  {
    vGap: 8,
    hGap: 8,
    vertical: false,
    justify: "start",
    alignContent: "start",
    alignItems: "start",
    wrap: false,
    full: false,
  }
)

// start/end 等 CSS 逻辑值在老式 WebView（微信 X5/XWeb 等 Chromium < 93）中不受支持，
// 统一映射为传统 flex 值；space-between/space-around 等保持原值
const flexValueMap: Record<string, string> = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
}

const containerStyle = computed(() => {
  return {
    display: "flex",
    "flex-direction": props.vertical ? "column" : "row",
    "flex-wrap": props.wrap ? "wrap" : "nowrap",
    "justify-content": flexValueMap[props.justify] ?? props.justify,
    "align-content": flexValueMap[props.alignContent] ?? props.alignContent,
    "align-items": flexValueMap[props.alignItems] ?? props.alignItems,
    gap: `${props.vGap}px ${props.hGap}px`,
    width: props.full ? "100%" : undefined,
  } as any
})
</script>
<style scoped></style>
